export default __webpack_public_path__ + "media/images/gallery/28-e450471bb80ebf0323ebb8d34441fb69.jpg";